import { ApolloError } from '@apollo/client';

import { ErrorBanner } from '@/components/banner';
import { isInvalidOperationError, isTimeoutError } from '@/lib/error/utils/timeout';

interface QueryErrorProps {
  error: ApolloError;
  minHeight?: number;
  refetch: () => void;
}

export const QueryError = ({ error, minHeight, refetch }: QueryErrorProps) => {
  const isTimeout = isTimeoutError(error);
  const isInvalidOperation = isInvalidOperationError(error);

  return isInvalidOperation ? (
    <ErrorBanner title="Invalid step" description={error.message} />
  ) : isTimeout ? (
    <ErrorBanner
      title={"Database didn't respond in time"}
      minHeight={minHeight}
      actions={[{ label: 'Retry', onClick: () => refetch() }]}
    />
  ) : (
    <ErrorBanner
      details={error.message}
      minHeight={minHeight}
      actions={[{ label: 'Retry', onClick: () => refetch() }]}
    />
  );
};
